import { Reducer } from 'redux'

import { ICertificatesState } from 'store/states/certificates.state'
import * as fromActions from 'store/actions/certificates.action'

import {
  initialCertificate,
  initialMyCertificate,
} from 'models/certificate.model'

export const initialState: ICertificatesState = {
  list: [],
  loading: true,
  certificateCourses: [],
  certificate: initialCertificate,
  myCertificates: [],
  myCertificate: initialMyCertificate,
}

export const reducer: Reducer<ICertificatesState> = (
  state: ICertificatesState = initialState,
  { type, payload }
) => {
  switch (type) {
    case fromActions.CERTIFICATES_ADMINISTRATION_LIST:
      return {
        ...state,
        loading: true,
      }

    case fromActions.CERTIFICATES_ADMINISTRATION_LIST_SUCCESS: {
      const { data: list } = payload
      return {
        ...state,
        list,
        loading: false,
      }
    }

    case fromActions.CERTIFICATE_COURSES_LIST:
      return {
        ...state,
        loading: false,
      }

    case fromActions.CERTIFICATE_COURSES_LIST_SUCCESS: {
      const { data: certificateCourses } = payload
      return {
        ...state,
        certificateCourses,
        loading: false,
      }
    }
    case fromActions.GET_ADMIN_CERTIFICATE:
      return {
        ...state,
        loading: true,
      }

    case fromActions.GET_ADMIN_CERTIFICATE_SUCCESS:
      return {
        ...state,
        certificate: payload,
        loading: false,
      }

    case fromActions.GET_MY_CERTIFICATES:
      return {
        ...state,
        loading: true,
      }

    case fromActions.GET_MY_CERTIFICATES_SUCCESS: {
      const { data: myCertificates } = payload
      return {
        ...state,
        myCertificates,
        loading: false,
      }
    }

    case fromActions.GET_MY_CERTIFICATE:
      return {
        ...state,
        loading: true,
      }

    case fromActions.GET_MY_CERTIFICATE_SUCCESS:
      return {
        ...state,
        myCertificate: payload,
        loading: false,
      }
    default:
      return state
  }
}
